export const SET_CONDITION = 'SET_CONDITION'

export const setCondition = (condition) => ({
  type: SET_CONDITION,
  condition
})
